import { render, staticRenderFns } from "./SurveySessionsTable.vue?vue&type=template&id=0f71a7d2&scoped=true&"
import script from "./SurveySessionsTable.vue?vue&type=script&lang=ts&"
export * from "./SurveySessionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SurveySessionsTable.vue?vue&type=style&index=0&id=0f71a7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71a7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardActions,VCheckbox,VDataTable})
